"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _ListItem = _interopRequireDefault(require("./ListItem.style"));

var _Typography = require("../../Typography");

var _Icon = _interopRequireDefault(require("../../Icon"));

var ListItem = function ListItem(_ref) {
  var date = _ref.date,
      copy = _ref.copy;
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, null, /*#__PURE__*/_react.default.createElement(_rebass.Box, {
    minWidth: date ? '9.1rem' : 'fit-content',
    marginRight: ['small', null, 'medium']
  }, date ? /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, {
    size: "xsmall"
  }, date) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "Disk",
    color: "#707070"
  })), /*#__PURE__*/_react.default.createElement(_rebass.Box, null, /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    paddingTop: date ? '0' : 'xsmall'
  }, copy)));
};

ListItem.propTypes = {
  date: _propTypes.default.string,
  copy: _propTypes.default.string.isRequired
};
ListItem.defaultProps = {
  date: null
};
var _default = ListItem;
exports.default = _default;